/**
 * @module router/modules/tools
 * @description 도구 라우트 모듈 — 내부 개발/운영 도구 페이지 경로를 정의합니다.
 * 현재 경로 조회(Route Search) 페이지가 포함됩니다.
 */
const routes = [
  {
    path: '/tools/route-search',
    name: '경로조회',
    component: () => import('../../views/tools/RouteSearchView.vue'),
    meta: { platform: 'web', menuYn: false, authorization: false }
  }
]

export default routes
